import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CircularProgress from '@mui/material/CircularProgress';

export default function LoadingPanel (props) {
    return (
        <ListItem>
            <ListItemIcon>
                <CircularProgress size={24} color="secondary" />
            </ListItemIcon>
            <ListItemText primary={props.message} />
        </ListItem>
    );
}